/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { Fragment } from 'react';
import { Input } from 'reactstrap';
import { ColumnInputProps } from '../../InputProps';
import { getSingleRowTableAddon } from '../tableUtils';

const InputWithCheckbox = (props: ColumnInputProps) => {

  const {
    isDisabled,
    index,
    universalTracker,
    handleFocus,
    handleCheckboxChange,
    updateColumn,
    displayCheckbox,
    column,
    inputColumn,
  } = props;

  const { name: label, code: inputName } = column;
  const { beforeAddon, afterAddon } = getSingleRowTableAddon({ ...props, columnCode: inputName });

  // Fallback to empty string to indicate that input is controlled component
  const currentValue = inputColumn.value || '';
  const checked = !!displayCheckbox[inputName];
  const checkboxId = `valueCheckbox-${inputName}-${index}-${universalTracker.getId()}`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { name, value } = e.target;
    updateColumn({
      code: name,
      value: value === '' ? undefined : value
    });
  };

  const disabled = isDisabled?.(props);

  return (
    <Fragment key={inputName}>
      <div className='inputGroupContainer form-check my-2'>
        <input
          disabled={!!disabled}
          type='checkbox'
          id={checkboxId}
          className='form-check-input'
          checked={checked}
          onChange={(e) => handleCheckboxChange(inputName, e.target.checked)}
        />
        <label htmlFor={checkboxId} className='strong form-check-label'>
          {label}
        </label>
      </div>
      <div className={!checked ? 'd-none mb-3' : ' mb-3'}>
        <div className='position-relative input-group mb-3'>
          {beforeAddon?.element || null}
          <Input
            type='text'
            autoComplete='off'
            className='styled-input'
            name={inputName}
            value={currentValue}
            aria-describedby='suffix'
            disabled={!!disabled}
            required={true}
            onFocus={handleFocus}
            onClick={handleFocus}
            onChange={handleChange}
          />
          {afterAddon?.element || null}
        </div>
      </div>
    </Fragment>
  );
}


export default InputWithCheckbox;
